/**
 * File custom.js.
 *
 *
 *
 * Contains scripts to for all any custom indvidaul scripts for the whole website
 */

(function ($) {
    function addParamToUrl(action, param, value) {
        var loc = window.location;

        // check if param exists
        var result = new RegExp(param + "=([^&]*)", "i").exec(loc.search);
        result = (result && result[1]) || "";

        if (action == "add") {
            // added seperately to append ? before params
            var url = loc.protocol + "//" + loc.host + loc.pathname + loc.search;

            // param doesn't exist in url, add it
            if (result == "") {
                //doesn't have any params
                if (loc.search == "") {
                    url += "?" + param + "=" + value;
                } else {
                    url += "&" + param + "=" + value;
                }
            }
        } else {
            var loc = window.location;
            var url = loc.protocol + "//" + loc.host + loc.pathname;
        }

        // rewrite the url
        window.history.pushState({
                path: url
            },
            "",
            url
        );
    }

    $(document).ready(function () {
        // add the video button (work with us page) and add the condition if the video exist add it.
        var $video = $(".work-with-us-section-three-inner-wrapper").find(
            "figure.wp-block-video video"
        );
        if ($video.length) {
            var $wrapper = $(".work-with-us-section-three-inner-wrapper");
            $($wrapper)
                .find("[data-attr = 'video-button']")
                .addClass("play-video-button");
        }
        // grab the video url and add it to the button to open the lightbox
        $(".play-video-button").click(function () {
            $location_url = $("figure.wp-block-video video").attr("src");
            // $(this).attr("data-fancybox", '');
            $(this).attr("href", $location_url);
        });

        //add class to manage the hover state for the front page slider
        $(".front-page-item").hover(function () {
            $(".front-page-item")
                .not(this)
                .toggleClass("not-hovered");
        });

        $("#primary-menu .stay-updated").on("click", function () {
            $(".barbarossa-subscription")
                .stop(true, true)
                .fadeIn(300)
                .addClass("toggled");
            addParamToUrl("add", "subscription", "open");
        });

        if (window.location.href.indexOf("?subscription=") > -1) {
            $("#primary-menu .stay-updated").trigger("click");
        }

        $("body").on("click", function (e) {
            // Close Subscription Form
            if ($(".barbarossa-subscription").hasClass("toggled")) {
                if (
                    $(e.target).is(".barbarossa-subscription") &&
                    !$(e.target).is(".stay-updated")
                ) {
                    $(".barbarossa-subscription")
                        .stop(true, true)
                        .fadeOut(300)
                        .removeClass("toggled");
                    addParamToUrl("clear", "", "");
                }
            }
        });

        $(".subscription-close span").on("click", function (e) {
            // Close Subscription Form
            if ($(".barbarossa-subscription").hasClass("toggled")) {
                $(".barbarossa-subscription")
                    .stop(true, true)
                    .fadeOut(300)
                    .removeClass("toggled");
                addParamToUrl("clear", "", "");
            }
        });

        new WOW().init();


    });
})(jQuery);